// src/components/ProductCard.js
import React from "react";
import "./ProductCard.css";
import { FaShoppingCart, FaTrash, FaPlus, FaMinus } from "react-icons/fa";

const defaultImg = "/no-image.png"; // pastikan file ini ada di public/

function ProductCard({
  image,
  name,
  category, // kategori utama
  subcategory, // sub kategori
  stock, // stok tampil (misal stok tersisa)
  maxStock, // stok maksimum untuk batas qty (stok asli)
  onAddToCart,
  selected,
  qty = 0,
  onQtyChange = () => {},
  onRemove = () => {},

  // opsional cart table
  renderCart = false,
  cart = [],
  onCartQtyChange = () => {},
  onCartRemove = () => {},
  onCartClear = () => {},
  onCartSubmit = () => {},
  cartSubmitting = false,
}) {
  const shownStock = Number.isFinite(Number(stock)) ? Number(stock) : 0;
  const limitStock = Number.isFinite(Number(maxStock))
    ? Number(maxStock)
    : Number.isFinite(Number(stock))
    ? Number(stock)
    : 0;

  const q = Number.isFinite(Number(qty)) ? Number(qty) : 0;

  const canDec = q > 1;
  const canInc = limitStock ? q < limitStock : true;

  const totalItems = cart.reduce((s, it) => s + (Number(it.qty) || 0), 0);

  return (
    <>
      <article className="product-card" role="group" aria-label={name}>
        <figure className="product-media">
          <img
            src={image || defaultImg}
            alt={name}
            loading="lazy"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = defaultImg;
            }}
          />
        </figure>

        <div className="product-info">
          <h3 className="product-name" title={name}>
            {name}
          </h3>

          <p className="product-meta">
            <span className="product-category">{category || "-"}</span>
            {subcategory ? (
              <>
                <span className="product-dot" aria-hidden="true">
                  •
                </span>
                <span className="product-subcategory">Sub: {subcategory}</span>
              </>
            ) : null}
          </p>

          <p className="product-meta">
            <span className="product-stock">Stok {shownStock}</span>
          </p>
        </div>

        <div className="product-actions">
          {selected ? (
            <div className="cart-controls" aria-label="Kontrol jumlah">
              <button
                type="button"
                className="qty-btn"
                onClick={() => onQtyChange(q - 1)}
                disabled={!canDec}
                aria-label="Kurangi"
                title="Kurangi"
              >
                <FaMinus />
              </button>

              <span className="qty-value" aria-live="polite">
                {q}
              </span>

              <button
                type="button"
                className="qty-btn"
                onClick={() => onQtyChange(q + 1)}
                disabled={!canInc}
                aria-label="Tambah"
                title="Tambah"
              >
                <FaPlus />
              </button>

              <button
                type="button"
                className="remove-btn"
                onClick={onRemove}
                title="Hapus dari keranjang"
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="add-to-cart-btn"
              onClick={onAddToCart}
              title="Tambah ke Keranjang"
              disabled={shownStock <= 0}
            >
              <FaShoppingCart className="add-icon" />
              Tambah ke Keranjang
            </button>
          )}
        </div>
      </article>

      {/* ====== OPSIONAL TABEL KERANJANG ====== */}
      {renderCart && (
        <section className="cart-table-card">
          <header className="cart-table-header">
            <h3>Keranjang</h3>
            <div className="cart-table-actions">
              <span className="cart-pill">Total item: {totalItems}</span>
              <button
                type="button"
                onClick={onCartClear}
                disabled={cart.length === 0}
                className="btn-ghost"
                title="Kosongkan keranjang"
              >
                Kosongkan
              </button>
              <button
                type="button"
                onClick={onCartSubmit}
                disabled={cart.length === 0 || cartSubmitting}
                className="btn-primary"
              >
                {cartSubmitting ? "Mengirim..." : "Ajukan"}
              </button>
            </div>
          </header>

          {cart.length === 0 ? (
            <div className="cart-table-empty">Keranjang kosong. Tambahkan produk.</div>
          ) : (
            <div className="cart-table-scroll">
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Foto</th>
                    <th>Produk</th>
                    <th>Kategori</th>
                    <th>Qty</th>
                    <th>Stok</th>
                    <th style={{ textAlign: "center" }}>Hapus</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((it) => {
                    const max = it.maxStock ?? it.stock ?? Infinity;
                    const v = Number(it.qty) || 0;
                    return (
                      <tr key={it.id}>
                        <td>
                          <img
                            src={it.image || defaultImg}
                            alt={it.name}
                            width={52}
                            height={52}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = defaultImg;
                            }}
                            style={{
                              objectFit: "contain",
                              borderRadius: 8,
                              background: "#fff",
                            }}
                          />
                        </td>
                        <td>
                          <div className="cart-row-title" title={it.name}>
                            {it.name}
                          </div>
                          <div className="cart-row-sub">ID: {it.id}</div>
                        </td>
                        <td>
                          <div>{it.category || "-"}</div>
                          {it.subcategory ? (
                            <div style={{ color: "#64748b", fontSize: 12 }}>
                              Sub: {it.subcategory}
                            </div>
                          ) : null}
                        </td>
                        <td>
                          <div className="qty-inline">
                            <button
                              type="button"
                              className="qty-mini"
                              onClick={() => onCartQtyChange(it.id, v - 1, max)}
                              disabled={v <= 1}
                              title="Kurangi"
                            >
                              <FaMinus />
                            </button>
                            <input
                              type="number"
                              min={1}
                              max={max}
                              value={v}
                              onChange={(e) =>
                                onCartQtyChange(it.id, Number(e.target.value), max)
                              }
                              className="qty-input"
                            />
                            <button
                              type="button"
                              className="qty-mini"
                              onClick={() => onCartQtyChange(it.id, v + 1, max)}
                              disabled={v >= max}
                              title="Tambah"
                            >
                              <FaPlus />
                            </button>
                          </div>
                        </td>
                        <td>{it.stock ?? "-"}</td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            type="button"
                            className="btn-danger-mini"
                            onClick={() => onCartRemove(it.id)}
                            title="Hapus"
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}
    </>
  );
}

export default ProductCard;
